export default __webpack_public_path__ + "static/about2-64a97a819a1a1092239882fb7e3fdd8e.jpg";